import React, { useState } from 'react';
import axios from 'axios';

import RegisterProfile from '../components/RegisterProfile';
import RegisterSocial from '../components/RegisterSocial';
import { useParams, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import { Container } from 'react-bootstrap';
import RegisterCheckout from '../components/RegisterCheckout';
import { ProfileProvider } from "../contexts/ProfileContext"; // Import ProfileProvider
import ProfileSwitcher from '../components/ProfileSwitcher';

const Register = () => {
	const [loggedIn, setLoggedIn] = useState(false);
	const API_URL = "https://api.viralgpt.com/auth";
    const navigate = useNavigate(); // For navigation after login
	const location = useLocation(); // Move location hook to top

	const [profile, setProfile] = useState(null);
	const [error, setError] = useState("");
	const [loading, setLoading] = useState(true);

	// Get URL parameters
	const queryParams = new URLSearchParams(location.search);
	const purchasePlan = queryParams.get('purchase');
	const interval = queryParams.get('interval');



	// Store URL parameters in state 
	const [urlParams] = useState({
		purchasePlan,
		interval
	});

	useEffect(() => {
		
		const params = new URLSearchParams(location.search);
		const purchasePlan = params.get('purchase');
		const interval = params.get('interval');

		if (localStorage.getItem("accessToken")){
			fetchProfileInfo();
			return;
		}

		if (!purchasePlan && !interval) {
			navigate('/pricing');
			
		} else if (purchasePlan && interval) {
			fetchProfileInfo();
			var amount = 0;
			if (purchasePlan == "pro") {
				if (interval == "monthly") {
					amount = 49;
				} else if (interval == "annual") {
					amount = 468;
				}
			} else if (purchasePlan == "basic") {
				if (interval == "monthly") {
					amount = 19;
				} else if (interval == "annual") {
					amount = 180;
				}
			}
			axios.post("https://api.viralgpt.com/pixel", {
				event: "AddToCart",
				price: amount
			}, {
				withCredentials: true
			  })
		}
	}, [navigate, location]);


	const fetchProfileInfo = async () => {
		try {
		  const accessToken = localStorage.getItem("accessToken");
		  if (!accessToken) throw new Error("No access token found. Please log in.");
	
		  const response = await fetch(`https://api.viralgpt.com/auth/profile`, {
			method: "GET", // Use POST method to fetch profile data
			headers: {
			  "Content-Type": "application/json",
			  Authorization: `Bearer ${accessToken}`,
			},
		  });
	
		  if (!response.ok) {
			throw new Error("Failed to fetch profile info.");
		  }

	
		  const profileData = await response.json();
		  setProfile(profileData.profile);
		  

			for (var i of Object.keys(profileData.profile.socials)) {
				
				if (profileData.profile.socials[i].planName === "pro" || profileData.profile.socials[i].planName === "basic") {
					navigate("/dashboard");
					return;
				}
			}
			
			if (!purchasePlan && !interval){
				navigate("/pricing");
				return;
			}
			if (profileData.profile.selectedProfile){
				setStep(3);
			} else if (!profileData.profile.selectedProfile){
				setStep(2);
			}
		  
		  setError(""); // Clear any previous errors
		  return 1
		} catch (err) {
		  console.error(err);
		  localStorage.removeItem("accessToken");
		  
		  
		  setError("Unable to load profile. Please try again later.");
		} finally {
		  setLoading(false);
		}
	  };

  

	// Validate the token
	const validateToken = async () => {
	  const accessToken = localStorage.getItem("accessToken");

	  try {
		if (!accessToken) return;
		const response = await fetch(`${API_URL}/validate`, {
		  method: "POST",
		  headers: {
			"Content-Type": "application/json",
		  },
		  body: JSON.stringify({ token: accessToken }),
		});
  
		if (!response.ok) {
		  console.warn("Token is invalid or expired. Redirecting to login...");
		  localStorage.removeItem("accessToken");
	  	
  
		} else {
		 
		  setLoggedIn(true);
		}
	  } catch (err) {
		console.error("Failed to validate token:", err);
		localStorage.removeItem("accessToken");
	  		
  
	  }
	};
  
	// Check token validity on component mount
	useEffect(() => {
	  validateToken();
	}, []);

  const { plan } = useParams(); 
  const [step, setStep] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const [email, setEmail] = useState('');
  const [fullName, setFullName] = useState('');
  const [password, setPassword] = useState('');
  // This callback is passed down and called after the user finishes step 1

  const stepOneComplete = async (emailForm, passwordForm) => {
    setEmail(emailForm);
    setPassword(passwordForm);

    try {
	  if (emailForm.credential){
		const response = await axios.post('https://api.viralgpt.com/auth/google', { token: emailForm.credential });

		// Store the JWT in localStorage or context
		localStorage.setItem('accessToken', response.data.accessToken);

		// Redirect user after successful login
		setStep(2);
		await fetchProfileInfo();
	  }
      const response = await axios.post('https://api.viralgpt.com/auth/register', {
        email: emailForm,
        password: passwordForm
      }, {
        withCredentials: true
      });

      console.log(response.data);

      const { accessToken } = response.data;
	  

	  const pixelData = {
		event: 'CompleteRegistration',
		email: emailForm
	  }
	  axios.post('https://api.viralgpt.com/pixel', pixelData, {
		withCredentials: true
	  }).catch(err => console.error('Error sending pixel data:', err));

      // Save tokens and navigate to the dashboard
      localStorage.setItem("accessToken", accessToken);
	  
      setStep(2);
	  await fetchProfileInfo();

    } catch (error) {
      if (error.response && error.response.status === 400) {
        alert(error.response.data.error);
      } else {
        console.error('Error registering:', error);
      }
    }
  };


  const stepTwoComplete = async () => {
	if (purchasePlan && interval) {
		await fetchProfileInfo();
		setStep(3);
		
		return;
	}/* else {
		navigate("/dashboard");
	}*/
  }




  return (
    <div>
		<h3 className="m-2">
          <a href="/" className="text-decoration-none">
            <span className="text-2xl font-semibold text-gray-900 d-flex align-items-center">
              <img 
                src="/images/logo-icon.png" 
                alt="Logo" 
                style={{width: '30px', height: '30px', marginRight: '8px'}} 
              />
              <span className="text-instagram">ViralGPT</span>
            </span>
          </a>
        </h3>
      {/* Pass the callback down as a prop to PurchaseUsername */}
	  <Container className="justify-content-center text-center max-w-lg mt-12" fluid>
   
      {step == 1 && <RegisterProfile complete={stepOneComplete}/>}
      
      {/* Conditionally render the footer based on stepTwo */}
      {step == 2 && 
	  (
		<>
		
	  <RegisterSocial isLoading={isLoading} complete={stepTwoComplete} forced={purchasePlan && interval}/>
	  </>
	  )}
      {step == 3 && 
	
	 
        <RegisterCheckout
          show={true}
          planName={purchasePlan}
          isAnnual={interval === 'annual'} 
		  profile={profile}
        />
		
      }
    </Container>
    </div>
  );
};

export default Register;
